import React from 'react';

import TimeRangeField from 'data-lake/components/DataLakeActionModals/TimeRangeField';
import FieldsFiltersField from 'data-lake/components/DataLakeActionModals/FieldsFiltersField';
import type { RetrievalFormFieldsComponentProps } from 'data-lake/Types';
import TableFilter from 'data-lake/components/DataLakeActionModals/TableFilter';

const ExternalFormFieldsComponent = ({ submitButtonText, hourOnly }: RetrievalFormFieldsComponentProps) => (
  <>
    <TableFilter />
    <TimeRangeField submitButtonText={submitButtonText} hourOnly={hourOnly} />
    <FieldsFiltersField />
  </>
);

export default ExternalFormFieldsComponent;
